window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  /**
   *
   * @param {*} elem - element
   * @param {*} stateOne - Default value
   * @param {*} stateTwo - Default value
   */
    toggleState: function (elem, stateOne, stateTwo) {
        var elem = document.querySelector(elem);
        elem.setAttribute('data-state', elem.getAttribute('data-state') === stateOne ? stateTwo : stateOne);
  },

  /**
   *
   * @param {*} drawToToggle - element
   * @param {*} evListenerElem - element
   */

  toggleDrawerCloseOtherOpenDrawers: function (drawToToggle, evListenerElem){

    $('.drawer-el').each(function(i) {
      if ($(this).attr('id') != drawToToggle.attr('id')) {
        $(this).attr('data-drawer-state', 'closed'); 
      }
      else {
        $(this).attr('data-drawer-state', $(this).attr('data-drawer-state') == 'closed' ? 'open' : 'closed')
      }
    });

    $('.drawer-toggle-el').each(function(i) {
      if ($(this).attr('id') != evListenerElem.attr('id')) {
        $(this).attr('data-drawer-state', 'closed'); 
      }
      else {
        $(this).attr('data-drawer-state', $(this).attr('data-drawer-state') == 'closed' ? 'open' : 'closed')
      }
    });
  }
};



/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }


  /**
   * Lazy load images off screen
   *
   * @returns {*}
   */

  function initLazyLoad() {

    var lazyloadImages;    

    if ("IntersectionObserver" in window) {
      lazyloadImages = document.querySelectorAll(".lazy");
      var imageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var image = entry.target;
            image.src = image.dataset.src;
            image.classList.remove("lazy");
            imageObserver.unobserve(image);
          }
        });
      });
  
      lazyloadImages.forEach(function(image) {
        imageObserver.observe(image);
      });
    } else {  
      var lazyloadThrottleTimeout;
      lazyloadImages = document.querySelectorAll(".lazy");
      
      function lazyload () {
        if(lazyloadThrottleTimeout) {
          clearTimeout(lazyloadThrottleTimeout);
        }    
  
        lazyloadThrottleTimeout = setTimeout(function() {
          var scrollTop = window.pageYOffset;
          lazyloadImages.forEach(function(img) {
              if(img.offsetTop < (window.innerHeight + scrollTop)) {
                img.src = img.dataset.src;
                img.classList.remove('lazy');
              }
          });
          if(lazyloadImages.length == 0) { 
            document.removeEventListener("scroll", lazyload);
            window.removeEventListener("resize", lazyload);
            window.removeEventListener("orientationChange", lazyload);
          }
        }, 20);
      }
  
      document.addEventListener("scroll", lazyload);
      window.addEventListener("resize", lazyload);
      window.addEventListener("orientationChange", lazyload);
    }
  }
  


  return {
    initLazyLoad: initLazyLoad,
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.firstAvailableVariant = this._getFirstAvailableVariant();
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));    
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {


        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = NaN;

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption = $element.val();
            //currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
         //currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

         selectedValues.forEach(function(option) {

          if (satisfied) {
            /* if (option.value === variant.) */
            satisfied = (parseInt(option) === variant.id);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {

      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      //this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Get first available variant
     *
     * @param  {object} variant - Currently selected variant
     */
    _getFirstAvailableVariant: function(variant) {
      var availableVariants = this.product.variants.filter(function(variant) {
        return variant.available == true;
      });

      if (!availableVariants) {
        return false
      }
      return availableVariants[0]
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function () {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    imageWrapper: '[data-image-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    numInputs: 'input[type="number"]',
    productCard: '.product-card',
    relatedProducts: '.related-products'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */

  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));

    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);


    this.initVariants();
    this.initImagesSwitch();
    this.productImageZoom();
    this.initQtySelector();
    this.selectFirstVariantAvailable();
    //this.initRelatedProducts();    
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Handles change events from the variant inputs
     */
    initVariants: function () {

      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        //originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };            

      this.variants = new slate.Variants(options);
      
      this.updateAddToCartState();
      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

      this.unavailableVariants = this.variants.product.variants.filter(function(variant) {
        return variant.available == false;
      });

      this.unavailableVariants.forEach(variant => {
        $('.swatch-input').filter(function(){return this.value == variant.id}).next().addClass('swatch-label--disabled');
      });
    },

    initImagesSwitch: function () {

      if (!$(selectors.productThumbs, this.$container).length) {
        return;
      }

      var self = this;

      $(selectors.productThumbs, this.$container).on('click', function (evt) {
        evt.preventDefault();

        var $el = $(this);
        var imageSrc = $el.attr('href');
        var imageSrcZoom = $el.data('zoom');


        self.switchImage(imageSrc, imageSrcZoom);
      });
    },

    productImageZoom: function () {
      if (!$(selectors.imageWrapper, this.$container).length) {
        return;
      }

      // Destroy zoom (in case it was already set), then set it up again
      $(selectors.imageWrapper, this.$container).trigger('zoom.destroy');

      $(selectors.imageWrapper, this.$container).zoom({

        url: $(selectors.productFeaturedImage, this.$container).data('zoom'),
        on: 'grab'

      });
    },

    switchImage: function (imageSrc, imageSrcZoom) {
      $(selectors.productFeaturedImage, this.$container)
        .attr('src', imageSrc)
        .data('zoom', imageSrcZoom);

      this.productImageZoom();
    },

    initQtySelector: function () {                
    },

    initRelatedProducts: function () {
      var $relatedProducts = this.$container.siblings(selectors.relatedProducts);

      if (!$relatedProducts.length) {
        return;
      }

      $relatedProducts.on('click.productCard', selectors.productCard, theme.ProductCard.onClick);
    },

    selectFirstVariantAvailable: function (evt) {
      
      if (this.productSingleObject.tags.indexOf('status--coming-soon') > -1)
      {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.comingSoon);
        return;
      }

      var variant = this.variants.firstAvailableVariant;

      if (variant) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        $('.swatch-input').filter(function(){return this.value == variant.id}).prop("checked", true);
      } 
      else 
      {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        return;
      }
    },
        
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {     

      if (this.productSingleObject.tags.indexOf('status--coming-soon') > -1)
      {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.comingSoon);
        return;
      }

      if (evt == null) {
          return;
      }

      var variant = evt.variant;

      if (!variant) {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        return;
      }
      
      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } 
      else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $('.swatch-input').filter(function(){return this.value== variant.id}).next().addClass('swatch-label--disabled');
      }
    },

    
    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;

      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);


      this.switchImage(sizedImgUrl);
      this.productImageZoom();
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
      $(selectors.productFeaturedImage).off('.product-page-section');
    }    
  });  

  return Product;
})();
/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 * @namespace header
 */


theme.Header = (function () {
	function Header() {

		theme.CartDrawer.init();
		theme.MobileNavDrawer.init();
		theme.SearchDrawer.init();
		theme.Popup.init();

        /*
		window.addEventListener('click', function(e){
			if (!document.getElementById('resourcesNav').contains(e.target)){
			$('#resourcesNav').removeClass('main-nav-list__list-item--active');
		  }
        });

		window.addEventListener('click', function(e){
			if (!document.getElementById('aboutNav').contains(e.target)){
				$('#aboutNav').removeClass('main-nav-list__list-item--active');		  }
		});
        */

		$('.drawer-el').click(function (evt) {
			evt.stopPropagation()
        });

		$('.site-search-form__input').click(function (evt) {
			evt.stopPropagation()
		});

		$(document).click(function(evt) {
			$('.drawer-el').attr('data-drawer-state', 'closed');
			$('#toggleMobileNav').attr('data-drawer-state', 'closed');
			$('#toggleCartDrawer').attr('data-drawer-state', 'closed');
			$('#searchToggle').attr('data-drawer-state', 'closed');
		});

		$('.main-nav-drop-down li a').click(function (evt) {
			evt.stopPropagation();
        });

		// Toggle active classes on main-nav-list items
		$('.main-nav-list__list-item--has-menu').click(function (evt) {
			evt.preventDefault();
			if ($(this).hasClass('main-nav-list__list-item--active')) {
				$(this).removeClass('main-nav-list__list-item--active');

			} else {
				// remove classes from all
				$('.main-nav-list__list-item--active').removeClass('main-nav-list__list-item--active');
				// add class to the one we clicked
				$(this).addClass('main-nav-list__list-item--active');
				evt.preventDefault();
			}
		});

		$('.js-top-menu-item-highlight').on('click', function(e) {
			const $header = $(e.currentTarget).parents('.header');
			$header.toggleClass('active');
		});

		$('.search-form--mobile .search-form__action').on('click', function(e) {
			console.log('aaa')
			$('.search-form--mobile').toggleClass('active');
		});

		//Dropdowns and animation handling
		var dropDownsInNav = document.getElementsByClassName('mobile-nav__drop-down-nav');
		//Close all dropdowns except shop[0] and ignore a clicked dropdown element when toggling
		function collapseAllDropdowns(element) {
			var i;
			for (i = 0; i < dropDownsInNav.length; i++) {
				if (dropDownsInNav[i] == element) {
					continue;
				}
				collapseDropdown(dropDownsInNav[i])
			}
        }

		//Fire on init
		collapseAllDropdowns();

		function collapseDropdown(element) {

			// get proper height of dropdown from its contents
			var dropDownHeight = element.scrollHeight;
			// temporarily disable css transitions
			var elementTransition = element.style.transition;
			element.style.transition = '';
			requestAnimationFrame(function () {
				//on next frame set explicit height. Can't transition from auto
				element.style.height = dropDownHeight + 'px';
				//renable transitions
				element.style.transition = elementTransition;
				//On next frame set height to 0 CSS transition will perform the animation
				requestAnimationFrame(function () {
					element.style.height = 0 + 'px';
				});
			});
			element.setAttribute('data-collapsed', 'true');
		}

		function expandDropdown(element) {
			//close other dropdowns
			collapseAllDropdowns(element);
			var dropdownHeight = element.scrollHeight;
			element.style.height = dropdownHeight + 'px';
			element.addEventListener('transitionend', function (e) {
				element.removeEventListener('transitionend', arguments.callee);
				// remove inline height style at end of transition
				element.style.height = null;
			});
			element.setAttribute('data-collapsed', 'false');
        }

		$('.mobile-nav-list__list-item--has-menu').click(function (e) {
			var dropDown = this.nextElementSibling;
			var isCollapsed = dropDown.getAttribute('data-collapsed') === 'true';
			if (isCollapsed) {
				expandDropdown(dropDown);
				dropDown.setAttribute('data-collapsed', 'false')
			} else {
				collapseDropdown(dropDown)
			}
		});
	}
	Header.prototype = $.extend({}, Header.prototype, {});
	return Header;
})();
/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 * @namespace featuredCollections
 */

theme.FeaturedCollections = ( function() {

	function FeaturedCollections() {}
	FeaturedCollections.prototype = $.extend( {}, FeaturedCollections.prototype, {} );
	return FeaturedCollections;
} )();


/**
 * ------------------------------------------------------------------------------
 * @namespace collectionSection
 */

theme.CollectionSection = (function() {
  'use strict';

  function Collection(container) {
    this.$container = $(container);
    theme.CollectionFilterDrawer.init();

/*     var sortBtn = document.querySelector('#sortByBtn');
    sortBtn.onclick = function (e) {
      slate.utils.toggleState('#bc-sf-filter-top-sorting', 'closed', 'open');
      e.preventDefault();
    }; */
  }

  Collection.prototype.onUnload = function() {
    theme.CollectionFilterDrawer.unload();
  };

  return Collection;
})();



theme.Cart = (function () {
  'use strict';

  function Cart(container) {

    this.$container = $(container);

  }

  return Cart;
})();

class Attendees
{
    constructor()
    {
        this.items = [];
    }
        
    onAttendeesChanged()
    {
        let total = $('.js-qty__num').val();                
    }
}

theme.Attendees = new Attendees();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
    
  });

  $('.address-edit-toggle').on('click', function(evt) {
    evt.stopPropagation()

    var formId = $(this).data('form-id');

    if (formId == null) {
      $(evt.target.parentNode).toggleClass('hide');
    }
    $('#EditAddress_' + formId).toggleClass('hide');
    $('.address-list__address-form form').scrollTop(0);

  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;
    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Modules ================*/

theme.CartDrawer = (function() {
    'use strict';

    var evListenerElem =  $('#toggleCartDrawer');
    var drawerElem = $('#cartDrawer');

    function init() {
        evListenerElem.bind( "click", function(evt) {
          evt.stopPropagation()
          drawerElem.attr('data-drawer-state', 'open');
        });

        $('#close-cart').on('click', function() {
          drawerElem.attr('data-drawer-state', 'closed');
        });
    };

    return {
      init: init
    };

  })();

theme.SearchDrawer = (function () {
  'use strict';

  var evListenerElem = $('#searchToggle');
  var drawerElem = $('#searchDrawer');


  $('.site-search-form__input')

  function init() {

    $('.site-search-form__input').bind("click", function (evt) {
      evt.stopPropagation()
    });


    evListenerElem.bind("click", function (evt) {

      evt.stopPropagation()
      slate.utils.toggleDrawerCloseOtherOpenDrawers(drawerElem, evListenerElem);
    });

  };

  return {
    init: init
  };

})();

theme.MobileNavDrawer = (function () {
  'use strict';

  var evListenerElem = $('#toggleMobileNav');
  var drawerElem = $('#mobileNav');

  function init() {
    evListenerElem.bind("click", function (evt) {
      evt.stopPropagation()
      slate.utils.toggleDrawerCloseOtherOpenDrawers(drawerElem, evListenerElem);
    });

    $('#close-menu').on('click', function() {
      drawerElem.attr('data-drawer-state', 'closed');
    });

    handleMobileNav();
  };

  function handleMobileNav() {
    const $menuMobile = $('.menu-mobile');
    const $menuMobileContent = $menuMobile.find('.menu-mobile__content');
    const $menuOpen = $menuMobile.find('#menu-open');
    const $menuClose = $menuMobile.find('#menu-close');

    $menuOpen.on('click', function() {
      $menuMobile.addClass('active');
      $menuMobileContent.fadeIn();
    });

    $menuClose.on('click', function() {
      $menuMobile.removeClass('active');
      $menuMobileContent.fadeOut();
    });

    $('.menu-list__category__action').on('click', function(e) {
      $(e.currentTarget).parent().toggleClass('active');
    });
  }

  return {
    init: init
  };

})();

theme.CollectionFilterDrawer = (function () {
  'use strict';

  var evListenerElem = $('#toggleCollectionFilterDrawer');
  var drawerElem = $('#collectionFilterDrawer');
  var closeDrawerElem = $('#closeCollectionFilterDrawer');

  function init() {
    evListenerElem.bind("click", function (evt) {
      evt.stopPropagation()
      slate.utils.toggleDrawerCloseOtherOpenDrawers(drawerElem, evListenerElem);
    });
    closeDrawerElem.bind("click", function (evt) {
      evt.stopPropagation()
      $(drawerElem).attr('data-drawer-state', 'closed');
    });

  };
  return {
    init: init
  };

})();

class Geolocation
{
    constructor()
    {
        this.apiKey = document.querySelector("html").dataset.googleMapKey;
        this.euCountryCodes = ["AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE","GB" ]
        this.storeCountry = document.querySelector("html").dataset.country;
        this.userCountry = null;
        this.selectors =
        {
            container : "#geolocation-popup",
            close_button: "#geolocation-popup__close",
            localStorage_geolocation_dismissed: "wasGeolocationDismissed"
        }

        this.addScriptToHead();

        this.onGotGeocode = (data) =>
        {
            if (!data.results) return;

            for (let result of data.results)
            {
                for (let address of result.address_components)
                {
                    if (address.types.indexOf("country") > -1)
                    {
                        this.userCountry = address.short_name;
                        return;
                    }
                }
            }
        }

        this.onGotPosition = (position) =>
        {
            this.getGeocode(position);
        }

        this.showRedirectIfRequired = () =>
        {
            const isUserOnCorrectSite = this.isUserOnCorrectSite();

            if (!isUserOnCorrectSite)
            {
                this.showPopup();
            }
            else
            {
                console.log('user is on correct site');
            }
        }

        this.isUserOnCorrectSite = () => (this.storeCountry == "NZ" && this.userCountry == "NZ")
            || (this.storeCountry != "AU" && this.userCountry == "AU")
            || (this.storeCountry != "UK" && this.isUserInEurope());

        this.isUserInEurope = () => this.euCountryCodes.indexOf(this.userCountry) > -1;

        this.wasPopupDismissed = () => localStorage.getItem(this.selectors.localStorage_geolocation_dismissed) == "true";
    }

    addScriptToHead()
    {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&callback=theme.Geolocation.onInitialized`;

        document.getElementsByTagName("head")[0].appendChild(script);
    }

    onInitialized()
    {
        if (navigator.geolocation)
        {
            navigator.geolocation.getCurrentPosition(this.onGotPosition);
        }
    }

    getGeocode(position)
    {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=${this.apiKey}`;

        $.get(url)
            .then(this.onGotGeocode)
            .then(this.showRedirectIfRequired);
    }

    showPopup()
    {
        if (this.wasPopupDismissed()) return;

        $(this.selectors.container).css("display", "flex");
        $(this.selectors.close_button).click(() => this.dismissPopup());
    }

    dismissPopup()
    {
        $(this.selectors.container).css("display", "none");
        localStorage.setItem(this.selectors.localStorage_geolocation_dismissed, "true");
    }
}

theme.Geolocation = new Geolocation();
/*!
 * JavaScript Cookie v2.1.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */

!function(e){if("function"==typeof define&&define.amd)define(e);else if("object"==typeof exports)module.exports=e();else{var n=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=n,t}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var t=arguments[e];for(var o in t)n[o]=t[o]}return n}function n(t){function o(n,r,i){var c;if(arguments.length>1){if(i=e({path:"/"},o.defaults,i),"number"==typeof i.expires){var s=new Date;s.setMilliseconds(s.getMilliseconds()+864e5*i.expires),i.expires=s}try{c=JSON.stringify(r),/^[\{\[]/.test(c)&&(r=c)}catch(a){}return r=t.write?t.write(r,n):encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=encodeURIComponent(String(n)),n=n.replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent),n=n.replace(/[\(\)]/g,escape),document.cookie=[n,"=",r,i.expires&&"; expires="+i.expires.toUTCString(),i.path&&"; path="+i.path,i.domain&&"; domain="+i.domain,i.secure?"; secure":""].join("")}n||(c={});for(var p=document.cookie?document.cookie.split("; "):[],d=/(%[0-9A-Z]{2})+/g,u=0;u<p.length;u++){var f=p[u].split("="),l=f[0].replace(d,decodeURIComponent),m=f.slice(1).join("=");'"'===m.charAt(0)&&(m=m.slice(1,-1));try{if(m=t.read?t.read(m,l):t(m,l)||m.replace(d,decodeURIComponent),this.json)try{m=JSON.parse(m)}catch(a){}if(n===l){c=m;break}n||(c[l]=m)}catch(a){}}return c}return o.get=o.set=o,o.getJSON=function(){return o.apply({json:!0},[].slice.call(arguments))},o.defaults={},o.remove=function(n,t){o(n,"",e(t,{expires:-1}))},o.withConverter=n,o}return n(function(){})});

theme.Popup = (function () {
  'use strict';

  var $popup = $('#popup');
  var $newsletterClose = $('#newsletter-close');

  function init() {
    var reappearTime = parseInt( $popup.data('reappear-time'));
    var testMode = $popup.data('testmode');

    if (testMode) {
      $('#popup').css('display','inline-block');
    } else {
      //If cookie doesn't exist or it's expired
      if (Cookies.get('newsletter_display') === undefined || reappearTime == 0){
        $('#popup').css('display','inline-block');
        createCookie(reappearTime);
      }
    }

    function createCookie(reappearTime){
      if (reappearTime != 0){
        Cookies.set('newsletter_display', 'value', { expires: reappearTime });
      }
    };

    $newsletterClose.on('click', function() {
      $('#popup').css('display','none');
    })
  };

  return {
    init: init
  };

})();


$(document).ready(function() {

  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('header', theme.Header);
  sections.register('collection-template', theme.CollectionSection);
  sections.register('featuredCollections', theme.featuredCollections);
  sections.register('cart', theme.Cart);
  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  slate.Image.initLazyLoad();
    $('.shopify-currency-form select').on('change', function() {
      $(this)
        .parents('form')
        .submit();
    });

  function handleBreadcrumbSize () {
    const CLASS_OVERFLOW = "is-overflow";
    const $el = $('.breadcrumb');
    const outsideWidth = $el.find(".active").width();
    const insideWith = $el.find(".active span").width();
    if (parseInt(insideWith) >= parseInt(outsideWidth)) {
      $el.addClass(CLASS_OVERFLOW);
    } else {
      $el.removeClass(CLASS_OVERFLOW);
    }
  }

  handleBreadcrumbSize();
  $(window).on('resize', function() {
    handleBreadcrumbSize();
  });
});
